import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import { Container, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import BundlePrice from 'Components/Bundle/BundlePrice';
import FluidImg from 'Components/Utility/FluidImg';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import Price from 'Components/Utility/Price/Price';

import 'Components/Bundle/BundleProductBar.scss';

const BundleProductBar = ({ bundle, pickAndMix, tiers }) => {
  const [open, setOpen] = useState(true);

  const closeBanner = () => {
    setOpen(false);
  };

  const slug = getUrlParameter('product');

  let product = {};
  const firstPnmTier = get(pickAndMix, 'tiers', [])[0];
  let singleItemPnmTier = false;

  if (!isEmpty(pickAndMix)) {
    pickAndMix.products.forEach((p) => {
      if (p.slug === slug) product = p;
    });

    if (firstPnmTier.quantity === 1) singleItemPnmTier = true;
  }

  if (!isEmpty(tiers)) {
    tiers.forEach((tier, index) => {
      const matchingGame = tier.games.find(game => game.slug === slug);
      if (matchingGame) {
        product = matchingGame;
        product.tier = tier;
        product.tierIndex = index + 1;
      }
    });
  }

  if (!slug || isEmpty(product) || !open) {
    return null;
  }

  const productTierPrice = get(product, 'tier.price', { GBP: 0 });
  const bundlePrice = get(bundle, 'currentPrice', get(bundle, 'price', { GBP: 0 }));
  const fullPrice = get(bundle, 'fullPrice', { GBP: 0 });
  const hideDiscount = get(product, 'hide_discount', false);
  const discountPercentOverride = get(bundle, 'discount_percent_override');
  const currentDiscount = get(bundle, 'current_discount', false);

  return (
    <div className="bundle-product-bar">
      <Container className="bundle-product-bar-content-container">
        {(product.type !== 'book' && product.type !== 'comic') &&
          <div className="bundle-product-bar-image-container">
            <div className="responsive-image-island">
              <div className="responsive-image responsive-image--16by9">
                <FluidImg
                  className="img-force-full"
                  src={product.cover}
                  alt={product.name}
                />
              </div>
            </div>
          </div>
        }
        {(product.type === 'book' || product.type === 'comic') &&
          <div className="bundle-product-bar-portrait-image-container">
            <FluidImg
              className="img-force-full"
              src={product.cover}
              alt={product.name}
            />
          </div>
        }
        <div className="product-detail-container">
          {!isEmpty(pickAndMix) && singleItemPnmTier &&
            <div className="buy-text">
              <FormattedMessage
                id="bundle-page.buyinpickandmixsingle"
                defaultMessage="Buy: {productName} for {price} in the {pickAndMixName}"
                values={{
                  productName: <u>{product.name}</u>,
                  pickAndMixName: pickAndMix.name,
                  price: <span className="price"><Price price={firstPnmTier.price} /></span>,
                }}
              />
            </div>
          }
          {!isEmpty(pickAndMix) && !singleItemPnmTier &&
            <div className="buy-text">
              <FormattedMessage
                id="bundle-page.buyinpickandmix"
                defaultMessage="Buy: {productName} and {quantity} more titles for {price} in the {pickAndMixName}"
                values={{
                  productName: <u>{product.name}</u>,
                  pickAndMixName: pickAndMix.name,
                  price: <span className="price"><Price price={firstPnmTier.price} /></span>,
                  quantity: firstPnmTier.quantity - 1,
                }}
              />
            </div>
          }
          {!isEmpty(tiers) && tiers.length > 1 &&
            <div className="buy-text">
              <FormattedMessage
                id="bundle-page.buyinbundle"
                defaultMessage="Buy: {productName} in Tier {tier} of {bundleName}"
                values={{
                  productName: <u>{product.name}</u>,
                  tier: product.tierIndex,
                  bundleName: bundle.name,
                }}
              />
            </div>
          }
          {!isEmpty(tiers) && tiers.length === 1 &&
            <div className="buy-text">
              <FormattedMessage
                id="bundle-page.buyinbundlemultitier"
                defaultMessage="Buy: {productName} and {gamesTotal, plural, one {# more title} other {# more titles}} in {bundleName}"
                values={{
                  bundleName: bundle.name,
                  productName: <u>{product.name}</u>,
                  gamesTotal: get(product, 'tier.games', []).length - 1,
                }}
              />
            </div>
          }

          {!isEmpty(tiers) && tiers.length > 1 &&
            <div className="tier-price">
              <Price price={productTierPrice} />
            </div>
          }

          {!isEmpty(tiers) && tiers.length === 1 &&
            <BundlePrice
              price={bundlePrice}
              fullPrice={fullPrice}
              hideDiscount={hideDiscount}
              discountPrice={currentDiscount}
              discountPercentOverride={discountPercentOverride}
            />
          }
        </div>
        <div className="close-button">
          <Button
            color="link"
            onClick={closeBanner}
          >
            <FontAwesomeIcon icon={faXmark} size="lg" title="Dismiss banner" />
          </Button>
        </div>
      </Container>
    </div>
  );
};

BundleProductBar.propTypes = {
  bundle: PropTypes.shape({}),
  pickAndMix: PropTypes.shape({}),
  tiers: PropTypes.arrayOf(PropTypes.object),
};

BundleProductBar.defaultProps = {
  bundle: {},
  pickAndMix: {},
  tiers: [],
};

export default BundleProductBar;

